import pouch from '@/db/pouch';

export default {
  addExpense({
    commit
  }, expense) {
    return new Promise(async (resolve, reject) => {
      try {
        return await pouch.c(expense, false).then((ct) => {
          if (ct.ok) {
            return resolve('Expense successfully saved');
          }
          return reject(ct.message);
        })
      } catch (e) {
        return reject(e);
      }
    })
  },
  updateExpense({
    commit
  }, expense) {
    return new Promise(async (resolve, reject) => {
      return await pouch.f({
        selector: {
          _id: expense._id,
          z: 7,
        }
      }, true, false).then(async (sr) => {
        if (sr.hasOwnProperty('a')) {
          return await pouch.c(expense, false).then((ct) => {
            if (ct.ok) {
              return resolve('Expense successfully updated');
            }
            return reject(ct.message);
          }).catch((e) => reject(e))
        } else {
          return reject('This expense has not been found. It might no longer exist in your database.');
        }
      });
    })
  },
}